// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "InspectJudgeDivergence" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";

export const InspectJudgeDivergenceGenShape = z.strictObject({
  deterministicRank1: z.string().optional(),
  judgePick: z.string().optional(),
  rank1Overridden: z.boolean(),
  failurePoint: z.string().optional(),
  rejected: z.array(z.string()),
  assumedCharacteristics: z.array(z.string()),
  bestRelevance: z.number().optional(),
  noGenuineFit: z.boolean(),
});
